import { render, staticRenderFns } from "./complianceLipChaeck.vue?vue&type=template&id=cebaef5c&scoped=true"
import script from "./complianceLipChaeck.vue?vue&type=script&lang=js"
export * from "./complianceLipChaeck.vue?vue&type=script&lang=js"
import style0 from "./complianceLipChaeck.vue?vue&type=style&index=0&id=cebaef5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebaef5c",
  null
  
)

export default component.exports